import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=e2dda664&scoped=true&"
import script from "./Money.vue?vue&type=script&lang=ts&"
export * from "./Money.vue?vue&type=script&lang=ts&"
import style0 from "./Money.vue?vue&type=style&index=0&id=e2dda664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dda664",
  null
  
)

export default component.exports